import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeDelay extends Shape {
    width = 200;
    height = 182;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 7) / 8 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + (width * 7) / 8, y + height);
        canv.ctx.arcTo(x, y + height, x, y, r);
        canv.ctx.arcTo(x, y, x + (width * 7) / 8, y, r);
        canv.ctx.lineTo(x + (width * 7) / 8, y);
        canv.ctx.moveTo(x + (width * 7) / 8, y);

        canv.ctx.ellipse(
            x + (width * 7) / 8,
            y + height / 2,
            width / 8,
            height / 2,
            0,
            Math.PI * 1.5,
            Math.PI * 0.5,
        );

        canv.ctx.moveTo(x + (width * 7) / 8, y + height);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="M1.34 2.1c2.37-.19 16.3-.07 16.85.05 6.2 1.05 6.61 18.65 0 19.72-.55.15-14.1.18-16.75.04-.28 0-.44-.2-.44-.48V2.5c0-.22.11-.39.34-.4Z"/>
            </svg>
        `;
    }
}
